import { get as _get } from 'lodash';
import { reduxStateMap, withReducerName } from './reduxMap';
import { actionTypes, logInSucceeded } from './registryActions';
import { apiUrl } from './utils';
import authService from '../authService';

export function logInThunk(user) {
    return async (dispatch) => {
        return dispatch(logInSucceeded(user));
    };
}

export function configurationThunk() {
    return async (dispatch) => {
        dispatch({ type: actionTypes.CONFIGURATION_START });
        const token = authService.getToken();
        await fetch(apiUrl('query/configuration'), {
            headers: !token ? {} : { Authorization: `Bearer ${token}` }
        })
            .then(async (response) => {
                if (response.status === 401) {
                    dispatch({ type: actionTypes.CONFIGURATION_FAILURE });
                    authService.logout();
                    window.location.href = '/';
                    return;
                    // await authService.userManager.signinSilent();
                    // dispatch(configurationThunk());
                    // return;
                }
                const data = await response.json();
                dispatch({ type: actionTypes.CONFIGURATION_SUCCESS, data });
            })
            .catch((reason) => {
                dispatch({ type: actionTypes.CONFIGURATION_FAILURE });
            });
    };
}

export function queryThunk() {
    return async (dispatch, getState) => {
        dispatch({ type: actionTypes.QUERY_START });
        const token = authService.getToken();
        const formValues = _get(getState(), withReducerName(reduxStateMap.FORM_VALUES));
        const [queryType, vehicleType, identifier] = [
            formValues[reduxStateMap.QUERY_TYPE],
            formValues[reduxStateMap.VEHICLE_TYPE],
            formValues[reduxStateMap.SEARCH_TERM]
        ];
        await fetch(apiUrl(`query?queryType=${queryType}&vehicleType=${vehicleType}&identifier=${identifier}`), {
            headers: !token ? {} : { Authorization: `Bearer ${token}` }
        })
            .then(async (response) => {
                if (response.status === 401) {
                    authService.logout();
                    window.location.href = '/';
                    return;
                }
                const data = await response.json();
                dispatch({ type: actionTypes.QUERY_SUCCESS, data });
            })
            .catch((reason) => {
                dispatch({ type: actionTypes.QUERY_FAILURE });
            });
    };
}
